{{#if confirmationMessage }}
    <div class="hdg hdg_5">Thank you!</div>
    <p class="bdcpy">An email has been sent to you with instructions for completing your account registration.</p>
{{else}}
    <div class="vr{{#if loading}} isDelayed{{/if}}">
        <div class="messageBox messageBox_tight" style="text-align: center;">
            <span class="bdcpy bdcpy_md">Register now and we'll give you 2,500 <a class="link link_md" target="_blank" href="https://smartpress.com/pages/print-points">Print Points</a>. <br>(That's $25 off your first purchase!)</span>
        </div>
        <div>
            <div class="hdg hdg_5">Register</div>
        </div>
        <form class="spdcForm hasRequired js-element--registerForm" action="">
            <div class="spdcForm-row">
                <div class="spdcForm-row-item isRequired{{#if errors.username}} spdcForm-row-item_hasErrors{{/if}}" id="userName">
                    <label class="spdcForm-lbl" for="username">Username</label>
                    <input class="spdcForm-input js-element--registerUsername" value="{{formValues.username}}" name="" id="username" type="text">
                    <div class="spdcForm-msg spdcForm-msg_error">{{errors.username}}</div>
                </div>
            </div>
            <div class="spdcForm-row spdcForm-row_2up">
                <div class="spdcForm-row-item isRequired{{#if errors.firstName}} spdcForm-row-item_hasErrors{{/if}}" id="firstName">
                    <label class="spdcForm-lbl" for="firstname">First Name</label>
                    <input class="spdcForm-input js-element--registerFirstName" value="{{formValues.firstName}}" name="" id="firstname" type="text">
                    <div class="spdcForm-msg spdcForm-msg_error">{{errors.firstName}}</div>
                </div>
                <div class="spdcForm-row-item isRequired{{#if errors.lastName}} spdcForm-row-item_hasErrors{{/if}}" id="lastName">
                    <label class="spdcForm-lbl" for="lastname">Last Name</label>
                    <input class="spdcForm-input js-element--registerLastName" value="{{formValues.lastName}}" name="" id="lastname" type="text">
                    <div class="spdcForm-msg spdcForm-msg_error">{{errors.lastName}}</div>
                </div>
            </div>
            <div class="spdcForm-row">
                <div class="spdcForm-row-item isRequired{{#if errors.email}} spdcForm-row-item_hasErrors{{/if}}" id="emailAddress">
                    <label class="spdcForm-lbl" for="emailaddress">Email</label>
                    <input class="spdcForm-input js-element--registerEmail" value="{{formValues.email}}" name="" id="emailaddress" pattern="[^@\s]+@[^@\s]+\.[^@\s]+" type="email">
                    <div class="spdcForm-msg spdcForm-msg_error">{{errors.email}}</div>
                </div>
            </div>
            <div class="spdcForm-row">
                <div class="spdcForm-row-item{{#if errors.company}} spdcForm-row-item_hasErrors{{/if}}" id="company">
                    <label class="spdcForm-lbl" for="company">Company</label>
                    <input class="spdcForm-input js-element--registerCompany" value="{{formValues.company}}" name="" id="company" type="text">
                    <div class="spdcForm-msg spdcForm-msg_error">{{errors.company}}</div>
                </div>
            </div>
            <div class="spdcForm-row">
                <div class="spdcForm-row-item spdcForm-row-item_alignRight">
                    <button class="btn btn_fullWidth">Register</button>
                </div>
            </div>
        </form>
        <div>
            <p class="bdcpy bdcpy_md"><strong>NOTE:</strong> Your email and other personal information is always safe with Smartpress. We will never sell or share your name with any other person or business. <a class="link link_md" href="https://smartpress.com/support/privacy-policy" target="_blank">Privacy Policy</a></p>
        </div>
    </div>
{{/if}}
